/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card-body.bank-account-picker[_ngcontent-%COMP%]{height:100%;display:flex;align-items:center}"];
export { styles as styles };
